import React, { useEffect, useState } from 'react'
import { Box, Button, Checkbox, Chip, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import pdf from '../../../../assets/Project_Images/Icons/pdf.png'
import reciept from '../../../../assets/Project_Images/Icons/reciept.png'
import details from '../../../../assets/Project_Images/Icons/details.png'
import { ApiConfirmInvoice, ApiDownloadInvoicepdf, ApiGetInvoiceList } from '../../../../apiService/Core/Apicall.tsx'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import { useDispatch, useSelector } from 'react-redux'
import { hideLoading, showLoading } from '../../../../Redux/loadingSlice.tsx'
import { RootState } from '../../../../Redux/Store.tsx'
import Loading from '../../../Loader/Loading.tsx'
import { Payment } from '@mui/icons-material'

function InvoiceListing({ selectedDate }) {
    const [invoicelist, setInvoiceList] = useState<any>([]);
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const [selected, setSelected] = useState<string[]>([]);
    const isSelected = (invoice: string) => selected.includes(invoice);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const loading = useSelector((state: any) => state.loader.isLoading);


    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const all = invoicelist.map((row) => row.invoice);
            setSelected(all);
        } else {
            setSelected([]);
        }
    };

    const handleClick = (invoice: string) => {
        const selectedIndex = selected.indexOf(invoice);
        let newSelected: string[] = [];

        if (selectedIndex === -1) {
            newSelected = [...selected, invoice];
        } else {
            newSelected = selected.filter((id) => id !== invoice);
        }

        setSelected(newSelected);
    };


    const getInvoivelist = async () => {
        setInvoiceList([])
        try {
            const data = `?userId=${userData.userId}&month=${selectedDate.month() + 1}&year=${selectedDate.year()}`
            // const data = `?&month=${selectedDate.month() + 1}&year=${selectedDate.year()}`
            const res = await ApiGetInvoiceList(data)
            setInvoiceList(res.data)
        } catch (error) {
            const message =
                error?.response?.data?.message || // API error message
                error?.message ||                 // JS error message
                String(error);
            toast.error(message)
        }

    }
    const downloadInvoice = async (shopperInvoiceId: any) => {
        try {
            const data = `?userId=${userData.userId}&shopperInvoiceId=${shopperInvoiceId}`
            // const data = `?&month=${selectedDate.month() + 1}&year=${selectedDate.year()}`
            const res = await ApiDownloadInvoicepdf(data)
            const blob = new Blob([res], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            link.download = `Invoice_${shopperInvoiceId}.pdf`;
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url)
            // setInvoiceList(res.data)
        } catch (error: any) {
            const message =
                error?.response?.data?.message || // API error message
                error?.message ||                 // JS error message
                String(error);
            toast.error(message)
        }

    }
    useEffect(() => {
        getInvoivelist()
    }, [selectedDate])

    const handleConfirmInvoice = async (shopperInvoiceId: any) => {
        try {
            const res = await ApiConfirmInvoice(shopperInvoiceId)
            if (res) {
                getInvoivelist()
            }
        } catch (error: any) {
            const message =
                error?.response?.data?.message || // API error message
                error?.message ||                 // JS error message
                String(error);
            toast.error(message)
        }
    }

    return (
        <TableContainer component={Paper} >
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell padding="checkbox">
                            <Checkbox
                                indeterminate={selected.length > 0 && selected.length < invoicelist.length}
                                checked={selected.length === invoicelist.length}
                                onChange={handleSelectAllClick}
                            />
                        </TableCell>
                        <TableCell>Invoice</TableCell>
                        <TableCell>Date/Time</TableCell>
                        <TableCell>Month</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Total</TableCell>
                        <TableCell>TXN ID</TableCell>
                        <TableCell>TXN Date</TableCell>
                        <TableCell>PDF</TableCell>
                        <TableCell>RECEIPTS</TableCell>
                        <TableCell>DETAILS</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {invoicelist.length > 0 ? (invoicelist.map((invoice, index) => {
                        const isItemSelected = isSelected(invoice?.shopperInvoiceId + index);
                        return (
                            <TableRow
                                hover
                                key={index}
                                selected={isItemSelected}
                                sx={{ cursor: 'pointer' }}
                            >
                                <TableCell padding="checkbox">
                                    <Checkbox
                                        checked={isItemSelected}
                                        onChange={() => handleClick(invoice?.shopperInvoiceId + index)}
                                    />
                                </TableCell>
                                <TableCell>{invoice?.shopperInvoiceId}</TableCell>
                                <TableCell>
                                    {dayjs(invoice?.createdOn).format('DD/MM/YYYY')}
                                    <Typography variant='body2' className='text-secondary'>{dayjs(invoice?.createdOn).format('hh:mm:ss A')}</Typography>
                                </TableCell>
                                <TableCell>{invoice.month}</TableCell>
                                <TableCell className='d-flex gap-3 align-itmes-center h-100 justify-content-center' sx={{border:'none'}}>
                                    <Chip label={invoice?.shopperInvoiceStatusId?.invoiceStatusName} sx={{ color: "#0000005A", fontWeight: 'bold' }} size="small" />
                                   {invoice?.shopperInvoiceStatusId?.invoiceStatusName === 'Pending Confirmation' ? ( <Button variant='outlined' className='button-primary-outlined py-1 px-3' onClick={() => { handleConfirmInvoice(invoice?.shopperInvoiceId) }} sx={{ fontSize: '12px !important' }}>Confirm</Button> ):''}
                                </TableCell>
                                <TableCell>${parseFloat(invoice?.totalAmountToPay).toFixed(2)}</TableCell>
                                <TableCell>
                                    {/* {invoice?.transactionId } */}
                                    <Typography variant='body2' className='text-secondary'>{invoice?.transactionId}</Typography>
                                </TableCell>
                                <TableCell>
                                    {/* {invoice?.dateTime } */}
                                    <Typography variant='body2' className='text-secondary'>
                                        {invoice?.transactionDate ? dayjs(invoice?.transactionDate).format('DD/MM/YYYY') : ''}&nbsp;<span>{invoice?.transactionDate ? dayjs(invoice?.transactionDate).format('hh:mm:ss A') : ''}</span>
                                    </Typography> </TableCell>
                                <TableCell>
                                    <IconButton onClick={() => { downloadInvoice(invoice?.shopperInvoiceId) }}>
                                        <Box component='img' className='w-50' src={pdf}></Box>
                                    </IconButton>
                                </TableCell>
                                <TableCell>
                                    <IconButton>
                                        <Box component='img' className='w-50' src={reciept}></Box>
                                    </IconButton>
                                </TableCell>
                                <TableCell>
                                    <IconButton onClick={() => { navigate(`/dashboard/invoices/invoice-details`, { state: { shopperInvoiceId: invoice?.shopperInvoiceId } }) }}>
                                        <Box component='img' className='w-50' src={details}></Box>
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        );
                    })) : <TableCell colSpan={12}><Typography>No Data Found</Typography></TableCell>}
                </TableBody>
            </Table>
            {loading && <Loading />}
        </TableContainer>
    )
}

export default InvoiceListing
